import { api, handleApiResponse, handleApiError } from '@/lib/api';
import { LoginRequest, LoginResponse, User } from '@/types';

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    try {
      const response = await api.post('/auth/login', credentials);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async logout(refreshToken?: string): Promise<void> {
    try {
      await api.post('/auth/logout', { refreshToken });
    } catch (error) {
      // Don't throw error on logout failure
      console.warn('Logout request failed:', error);
    }
  },

  async refreshToken(refreshToken: string): Promise<{ accessToken: string; refreshToken: string }> {
    try {
      const response = await api.post('/auth/refresh', { refreshToken });
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async getProfile(): Promise<{ user: User }> {
    try {
      const response = await api.get('/auth/profile');
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    try {
      const response = await api.post('/auth/change-password', {
        currentPassword,
        newPassword,
      });
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
    }
  },

  async createUser(userData: {
    email: string;
    name: string;
    password: string;
    role?: string;
  }): Promise<{ user: User }> {
    try {
      const response = await api.post('/auth/register', userData);
      return handleApiResponse(response);
    } catch (error) {
      handleApiError(error);
      throw error;
    }
  },
};
